<template>
  <!-- 适用对象 -->
  <div :class="isPcFlag ? 'applicable-objects-pc' : 'applicable-objects-h5'">
    <div class="content">
      <div class="title">适用对象</div>
      <div class="card-list">
        <div class="card-item" v-for="(item, index) in list" :key="index">
          <p class="item-title">{{ item.title }}</p>
          <div class="tabs-box">
            <div class="tabs-item" v-for="(v, i) in item.list" :key="i">
              <img class="img" :src="v.img" />
              <div class="text">
                <p v-if="!isPcFlag">{{ v.textOne }}</p>
                <p v-if="!isPcFlag">{{ v.textTwo }}</p>
                <p v-else>{{ v.textAll }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isPcFlag: Boolean, // 是Pc还是H5
    list: {
      type: Array,
      default: [],
    },
  },
  mounted() {
    // console.log(this.list, 'list')
  },
}
</script>

<style lang="less" scoped>
.basisDisplay(@justify,@align) {
  display: flex;
  justify-content: @justify;
  align-items: @align;
}
.columnDisplay(@justify,@align) {
  display: flex;
  flex-direction: column;
  justify-content: @justify;
  align-items: @align;
}
// PC样式
.applicable-objects-pc {
  width: 100%;
  background: #fff;
  padding: 72px 0;
  .content {
    max-width: 1320px;
    height: 100%;
    margin: 0 auto;
    .columnDisplay(flex-start,center);
    .title {
      margin-bottom: 46px;
      font-size: 32px;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
    }
    .card-list {
      width: 100%;
      .basisDisplay(center,center);
      .card-item {
        width: 648px;
        height: 206px;
        background: #f7f8fa;
        margin: 0 12px;
        .item-title {
          padding: 18px 0 23px 25px;
          font-size: 20px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.85);
        }
        .tabs-box {
          .basisDisplay(space-around,center);
          .tabs-item {
            .columnDisplay(center,center);
            .img {
              width: 72px;
              height: 72px;
              margin-bottom: 8px;
            }
            .text {
              font-size: 18px;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.85);
            }
          }
        }
      }
    }
  }
}
// H5样式
.applicable-objects-h5 {
  width: 100%;
  background: #fff;
  padding: 1.0667rem 0.4rem;
  .content {
    max-width: 10rem;
    height: 100%;
    margin: 0 auto;
    .columnDisplay(flex-start,center);
    .title {
      margin-bottom: 0.64rem;
      font-size: 0.48rem;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
    }
    .card-list {
      width: 100%;
      .columnDisplay(center,center);
      .card-item {
        width: 9.1733rem;
        height: 5.04rem;
        background: #f7f8fa;
        margin-bottom: 0.48rem;
        border-radius: 0.2133rem;
        .item-title {
          padding: 0.4533rem 0 0.4533rem 0.3733rem;
          font-size: 0.4267rem;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.85);
        }
        .tabs-box {
          .basisDisplay(space-around,center);
          .tabs-item {
            .columnDisplay(center,center);
            .img {
              width: 1.9467rem;
              height: 1.9467rem;
            }
            .text {
              width: 1.8667rem;
              font-size: 0.3733rem;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.85);
              text-align: center;
            }
          }
        }
      }
    }
  }
}
</style>